import React from 'react';
import { RadioGroup, RadioGroupItem } from '../../ui/radio-group';

const WindowLockApprovalSection = ({ submission, jsonContent, isDark }) => {
    if (submission.sending !== 'Minutes' && jsonContent.sending !== 'Minutes') return null;

    return (
        <div className={`rounded-[10px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.11)] p-[20px] flex flex-col gap-[12px] transition-colors duration-200 ${
            isDark ? 'bg-[#000000]' : 'bg-white'
        }`}>
            <p className={`m-0 text-[16px] font-semibold transition-colors duration-200 ${
                isDark ? 'text-white' : 'text-[#072837]'
            }`}>Was the Quote for Window Locks approved?</p>
            {(submission.windowLockApproval || jsonContent.windowLockApproval) && (
                <RadioGroup value={submission.windowLockApproval || jsonContent.windowLockApproval}>
                    <div className='flex flex-col gap-[14px]'>
                        {(submission.windowLockApproval === 'No' || jsonContent.windowLockApproval === 'No') && (
                            <div className='flex gap-[8px] items-center'>
                                <RadioGroupItem value="No" id="windowLock-minutes-no" />
                                <label htmlFor="windowLock-minutes-no" className={`text-[16px] m-0 cursor-default transition-colors duration-200 ${
                                    isDark ? 'text-white' : 'text-[#072837]'
                                }`}>No</label>
                            </div>
                        )}
                        {(submission.windowLockApproval === 'Yes, Qsec' || jsonContent.windowLockApproval === 'Yes, Qsec') && (
                            <div className='flex gap-[8px] items-center'>
                                <RadioGroupItem value="Yes, Qsec" id="windowLock-minutes-yes_qsec" />
                                <label htmlFor="windowLock-minutes-yes_qsec" className={`text-[16px] m-0 cursor-default transition-colors duration-200 ${
                                    isDark ? 'text-white' : 'text-[#072837]'
                                }`}>Yes, Qsec</label>
                            </div>
                        )}
                        {(submission.windowLockApproval === 'Yes (name contractor)' || jsonContent.windowLockApproval === 'Yes (name contractor)') && (
                            <div className='flex gap-[8px] items-center'>
                                <RadioGroupItem value="Yes (name contractor)" id="windowLock-minutes-yes-contractor" />
                                <label htmlFor="windowLock-minutes-yes-contractor" className={`text-[16px] m-0 cursor-default transition-colors duration-200 ${
                                    isDark ? 'text-white' : 'text-[#072837]'
                                }`}>Yes (name contractor)</label>
                            </div>
                        )}
                    </div>
                </RadioGroup>
            )}

            {/* Contractor Name (conditional) */}
            {(submission.windowLockApproval === 'Yes (name contractor)' ||
                jsonContent.windowLockApproval === 'Yes (name contractor)') && (
                    <div className='flex flex-col gap-[8px]'>
                        <input 
                            className={`w-full px-[16px] py-[12px] rounded-[8px] border-none text-[16px] transition-colors duration-200 focus:outline-none focus:ring-0 focus:border-transparent ${
                                isDark 
                                    ? 'bg-[#161515]  text-white' 
                                    : 'bg-[#f5f5f5] text-[#072837]'
                            }`} 
                            type="text" 
                            value={submission.contractorName || jsonContent.contractorName || ''} 
                            readOnly 
                        />
                    </div>
                )}
        </div>
    );
};

export default WindowLockApprovalSection;
